import StarButton from "./StarButton";

export default StarButton;
